"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FundsServiceImpl {
    fundsRepository;
    constructor(fundsRepository) {
        this.fundsRepository = fundsRepository;
    }
    async getFunds() {
        return this.fundsRepository.getFunds();
    }
    async findFund(fundId) {
        return this.fundsRepository.findFund(fundId);
    }
    async getFundComposition(fundId) {
        return this.fundsRepository.getFundComposition(fundId);
    }
    async getHistorySharePrice({ fundId, series, }) {
        const response = await this.fundsRepository.getHistorySharePrice(fundId, series);
        return response.map((history) => ({
            ...history,
            formattedDate: `${new Date(history?.date).getDate()}/${new Date(history?.date).getMonth() + 1}/${new Date(history?.date).getFullYear()}`,
        }));
    }
    async getReturn(params) {
        return this.fundsRepository.getReturn(params);
    }
    async getPivoltFundHistory({ fundId, date, }) {
        const response = await this.fundsRepository.getPivoltFundHistory(fundId, date);
        return response.items;
    }
}
exports.default = FundsServiceImpl;
//# sourceMappingURL=FundsServiceImpl.js.map